module.exports = __webpack_public_path__ + "img/9788989646587.8e8151d8.jpg";